<header class="modal-header" mat-dialog-title>
  <div class="flex items-baseline">
    <h2 class="!text-2xl modal-headline" i18n>Select columns</h2>

    <div class="ml-auto">
      <button mat-icon-button mat-dialog-close class="button-close">
        <mat-icon class="material-icons-outlined" aria-hidden="true">close</mat-icon>
        <span class="sr-only" i18n>Close</span>
      </button>
    </div>
  </div>
</header>
<mat-dialog-content class="mat-typography">
  <div class="text-[#121212]/[56%]" i18n>Drag to reorder</div>
  <div class="flex gap-4 justify-center">
    <div class="flex-1">
      <div class="flex flex-col">
        <mat-checkbox class="example-margin" [checked]="allComplete" [indeterminate]="someComplete()" (change)="setAll($event.checked)"> Select all </mat-checkbox>
        <div class="column-list" *ngFor="let col of stickyTableCols">
          <mat-checkbox [checked]="col.visible" [disabled]="col.sticky" [ngClass]="!col.type || col.type === TableColumnType.checkbox ? '!hidden' : ''">{{ col.header }}</mat-checkbox>
        </div>
      </div>
      <div #tableColsList="cdkDropList" class="column-list-box" cdkDropList [cdkDropListData]="tableCols" (cdkDropListDropped)="drop($any($event))">
        <div class="column-list" *ngFor="let col of tableCols; index as i" cdkDrag [cdkDragData]="col" [cdkDragDisabled]="!col.visible || col.sticky">
          <mat-checkbox [checked]="col.visible" [disabled]="col.sticky" (change)="defaultColChange($event.checked, col, i)">{{ col.header }}</mat-checkbox>
        </div>
      </div>
    </div>
    <mat-divider vertical="true"></mat-divider>
    <div
      #additionalTableColsList="cdkDropList"
      class="column-list-box flex-1"
      cdkDropList
      [cdkDropListConnectedTo]="[tableColsList]"
      [cdkDropListData]="additionalTableCols"
      (cdkDropListDropped)="drop($any($event))"
    >
      <div class="column-list" *ngFor="let col of additionalTableCols; index as i" cdkDrag [cdkDragDisabled]="!col.visible">
        <mat-checkbox [checked]="col.visible" (change)="addColChange($event.checked, col, i)">{{ col.header }}</mat-checkbox>
      </div>
      <ng-template [ngIf]="sharedTaskStatusColumn && sharedTaskStatusColumn.length > 0">
        <div class="text-[#121212]/[56%]">Shared task status</div>
        <div class="column-list" *ngFor="let col of sharedTaskStatusColumn; index as i" cdkDrag [cdkDragDisabled]="!col.visible">
          <mat-checkbox [checked]="col.visible" (change)="addColChangeSharedStatus($event.checked, col, i)">{{ col.header }}</mat-checkbox>
        </div>
      </ng-template>
    </div>
  </div>
</mat-dialog-content>
<mat-dialog-actions align="center" class="dailog-action w-full gap-4 !justify-between">
  <button type="button" class="button-primary" mat-flat-button (click)="resetView()">
    <mat-icon class="material-icons-outlined ml-2">restart_alt</mat-icon>
    <span i18n>Reset</span>
  </button>
  <button type="button" class="save-button button-primary" mat-flat-button (click)="saveView()">
    <mat-icon class="material-icons-outlined ml-2">save</mat-icon>
    <span i18n>Save</span>
  </button>
</mat-dialog-actions>
